import { Skeleton } from '@/components/ui/Skeleton'

export function GroupSkeleton() {
  return (
    <div className="p-4 md:p-6" role="status" aria-label="그룹 로딩 중">
      {/* Header skeleton */}
      <div className="flex items-center justify-between mb-6">
        <div className="space-y-2">
          <Skeleton variant="text" width={80} height={24} />
          <Skeleton variant="text" width={200} height={14} />
        </div>
        <div className="flex items-center gap-2">
          <Skeleton variant="rectangular" width={80} height={36} />
          <Skeleton variant="rectangular" width={80} height={36} />
        </div>
      </div>

      {/* Group cards grid skeleton */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {Array.from({ length: 6 }).map((_, i) => (
          <div
            key={i}
            className="p-4 rounded-xl border border-base bg-surface-primary"
          >
            <div className="flex items-center gap-2 mb-3">
              <Skeleton variant="circular" width={12} height={12} />
              <Skeleton variant="text" width={120} height={16} />
            </div>
            <Skeleton variant="text" width="80%" height={12} className="mb-3" />
            <div className="space-y-1.5">
              <div className="flex items-center justify-between">
                <Skeleton variant="text" width={60} height={12} />
                <Skeleton variant="text" width={30} height={12} />
              </div>
              <Skeleton variant="rectangular" width="100%" height={8} />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
